<template>
    <div class="avance">
        <div class="container my-5 pb-5 text-bat">
            <div v-if="learnings !== null && learnings.data && learnings.data.length" class="row">
                <div v-for="learning in learnings.data" class="col-12 col-md-6 col-lg-6 col-xl-4">
                    <!-- Nuevo Diseño Cards Inicio -->
                    <div :class="learning.users.length === 0 ? 'blue' : learning.users[0].pivot.status === 'pending' ? 'orange' : 'green'" class="bg-white rounded-4 py-2 px-3 shadow mb-4 mb-md-3">
                        <div class="header-learning row ">
                            <div class="col-3">
                                <div class="img-learning justify-content-center align-content-center overflow-hidden" style="width: 75px; max-height: 100px">
                                    <img v-if="learning.image" :src="learning.image" style="max-width: 100%; max-height: 100%; display: block" :alt="learning.title" class="img-fluid rounded-3 mx-auto">
                                    <img v-else src="https://dummyimage.com/300x300" :alt="learning.title" style="max-width: 100%; max-height: 100%; display: block" class="img-fluid rounded-3 mx-auto">
                                </div>
                            </div>
                            <div class="col-5">
                                <h6 class="text-indigo-dark mb-0">
                                    {{ learning.title }}
                                </h6>
                                <span class="fs-7">
                                    <strong>
                                        Puntos: {{ learning.points_to_win }}
                                    </strong>
                                </span>
                            </div>
                            <div class="col-4 text-end text-white">
                                <span v-if="learning.users.length === 0" class="estado blue text-title-bat px-2 py-1 rounded-2 fs-7">
                                    Sin iniciar
                                </span>
                                <span v-else-if="learning.users[0].pivot.status === 'pending'" class="estado orange text-title-bat px-2 py-1 rounded-2 fs-7">
                                    Incompleto
                                </span>
                                <span v-else-if="learning.users[0].pivot.status === 'completed'" class="estado green text-title-bat px-2 py-1 rounded-2 fs-7">
                                    Completado
                                </span>
                            </div>
                        </div>
                        <div class="body-learning mb-0 mt-2">
                            <p>{{ learning.short_description }}</p>
                        </div>
                        <div class="footer-learning d-flex justify-content-start mb-2">
                            <div>
                                <a v-if="learning.users.length === 0" :href="`/learning/${learning.id}`" class="text-decoration-underline text-title-bat text-indigo fs-7">
                                    Comenzar >
                                </a>
                                <a v-else-if="learning.users[0].pivot.status === 'pending'" :href="`/learning/${learning.id}`" class="text-decoration-underline text-title-bat text-indigo fs-7">
                                    Continuar >
                                </a>
                                <a v-else-if="learning.users[0].pivot.status === 'completed'" :href="`/learning/${learning.id}`" class="text-decoration-underline text-title-bat text-indigo fs-7">
                                    Repasar >
                                </a>
                            </div>
                            <div v-if="learning.has_quiz && learning.users.length && learning.users[0].pivot.status === 'completed'">
                                <a v-if="learning.users[0].pivot.quiz_presented === 0" :href="`/learning/${learning.id}/quiz`" class="ms-3 text-decoration-underline text-title-bat text-indigo fs-7">Presentar Quiz ></a>
                                <a v-else-if="learning.users[0].pivot.score === null" class="ms-3 text-decoration-underline text-title-bat text-indigo fs-7" href="#" @click="modal_revision = true">Retroalimentación ></a>
                                <a v-else-if="learning.users[0].pivot.score != null" :href="`/learning/${learning.id}/quiz/feedback`" class="ms-3 text-decoration-underline text-title-bat text-indigo fs-7">Retroalimentación ></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="learnings.last_page > 1">
                    <div class="col-md-6 d-flex justify-content-center">
                        <ul class="pagination my-2">
                            <li class="page-item" :class="learnings.prev_page_url === null ? 'disable' : ''">
                                <a v-if="learnings.current_page-1 > 1" class="page-link cursor-pointer" @click="getLearnings(learnings.current_page - 1)">Anterior</a>
                                <span v-else class="cursor-block"><</span>
                            </li>
                            <li class="page-item">
                                <a v-if="learnings.current_page-2 > 1" @click="getLearnings(1)" class="p-2 page-link cursor-pointer">{{ 1 }}</a>
                            </li>
                            <li v-if="learnings.current_page-2 >= 1" class="page-item">
                                <span class="page-link">...</span>
                            </li>
                            <li v-if="learnings.current_page > 1" class="page-item">
                                <a @click="getLearnings(learnings.current_page - 1)" class="p-2 page-link cursor-pointer">{{ learnings.current_page - 1 }}</a>
                            </li>
                            <li class="page-item active">
                                <a class="p-2 page-link cursor-default">{{ learnings.current_page }}</a>
                            </li>
                            <li v-if="learnings.current_page < learnings.last_page" class="page-item">
                                <a @click="getLearnings(learnings.current_page + 1)" class="p-2 page-link cursor-pointer">{{ learnings.current_page + 1 }}</a>
                            </li>
                            <li v-if="learnings.current_page+2 <= learnings.last_page" class="page-item">
                                <a class="p-2 page-link">...</a>
                            </li>
                            <li v-if="learnings.current_page+2 < learnings.last_page" class="page-item">
                                <a @click="getLearnings(learnings.last_page)" class="p-2 page-link cursor-pointer">{{ learnings.last_page }}</a>
                            </li>
                            <li class="page-item" :class="learnings.current_page >= learnings.last_page ? 'disable' : ''">
                                <span v-if="learnings.current_page !== learnings.last_page" @click="getLearnings(learnings.current_page + 1)" class="cursor-pointer">></span>
                                <span v-else class="cursor-block">></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else-if="learnings === null && loading">
                <initial-loading></initial-loading>
            </div>
            <div v-else class="text-center mt-5">
                <h5 class="mt-5 text-title-bat text-indigo">Actualmente no hay contenido disponibles</h5>
            </div>
        </div>
        <el-dialog
            :visible.sync="modal_revision"
            :width="$mq ==='sm' ? '95%' : 'md' ? '35%' : '20%'"
            :close-on-press-escape="true"
            :close-on-click-modal="true"
            :show-close="true">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                <i class="fa-solid fa-triangle-exclamation fs-1 mb-3" style="color: #fec52f;"></i>
                <h4 class="text-indigo-darkness">Tu quiz está en proceso de revisión.</h4>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        url_storage: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            learnings: null,
            modal_revision: false,
            currentPage: 1,
        }
    },
    created () {
        const urlParams = new URLSearchParams(window.location.search);
        this.currentPage = (urlParams.get('option') === 'learning')?parseInt(urlParams.get('page')) || 1:1;
        this.getLearnings(this.currentPage);
    },
    methods: {
        updateUrlLearning() {
            const queryParams = new URLSearchParams();
            let url = '';
            queryParams.set('option', 'learning');
            if (this.currentPage !== 1 ) {
                queryParams.set('page', this.currentPage);
            }
            url += `?${queryParams.toString()}`;
            window.history.pushState({}, '', url);
        },
        getLearnings(page){
            const urlParams = new URLSearchParams(window.location.search);
            this.loading++
            axios.get(`/get-learnings?page=${page}`)
                 .then(({data}) => {
                     this.learnings = data.learnings
                     this.loading--;
                     this.currentPage = page;
                     if(urlParams.get('option') === 'learning'){
                         this.updateUrlLearning();
                     }
                 })
        },
    },
}

</script>
